import { Component, OnInit } from '@angular/core';

import {
  NbDialogRef,
  NbToastrService
} from '@nebular/theme';

import { FirebaseRepositoryService }
  from '../../firebase-repository.service';

import { AuthFirebaseService } from '../../auth-firebase.service';

@Component({
  selector: 'ngx-solicitar-autorizacion',

  templateUrl:
    './solicitar-autorizacion.component.html',

  styleUrls: [
    './solicitar-autorizacion.component.scss'
  ]
})
export class SolicitarAutorizacionComponent
  implements OnInit {

  /*
   * Usuario que ha seleccionado el administrador.
   */
  userData: any;

  /*
   * PDF seleccionado.
   */
  fileBase64: string = null;

  fileName: string = null;

  loading = false;

  constructor(
    private repoService:
      FirebaseRepositoryService,

    private toastrService:
      NbToastrService,

    private authService: 
      AuthFirebaseService
  ) {}

  ngOnInit(): void {
  }


  /*
   * ============================================================
   * DESCARGAR MODELO
   * ============================================================
   */
  descargarModelo(): void {

    const idowner =
      this.authService.pendingUser;

    if (!idowner) {

      this.toastrService.danger(
        'No se ha podido obtener el identificador del titular.',
        'Error'
      );

      return;
    }

    this.loading = true;

    this.repoService
      .descargarModelo(idowner)
      .subscribe(
        (data: any) => {

          this.loading = false;

          /*
           * Se espera que la Function devuelva
           * el PDF en base64.
           */
          const base64 =
            data?.file ||
            data?.data;

          if (!base64) {

            this.toastrService.danger(
              'No se ha recibido el modelo de autorización.',
              'Error'
            );

            return;
          }

          this.descargarPdf(
            base64,
            data?.fileName ||
              'modelo-autorizacion.pdf'
          );
        },

        error => {

          this.loading = false;

          console.error(
            'Error descargarModelo',
            error
          );

          this.toastrService.danger(
            'No se ha podido descargar el modelo de autorización.',
            'Error'
          );
        }
      );
  }

  /*
   * ============================================================
   * SELECCIONAR PDF
   * ============================================================
   */
  seleccionarArchivo(event: any): void {

    const file: File =
      event.target.files?.[0];

    if (!file) {
      return;
    }

    if (file.type !== 'application/pdf') {

      this.toastrService.warning(
        'El archivo seleccionado debe ser un PDF.',
        'Archivo no válido'
      );

      event.target.value = '';

      return;
    }

    this.fileName = file.name;

    const reader =
      new FileReader();

    reader.onload = () => {

      const result =
        reader.result as string;

      /*
       * El resultado tiene:
       *
       * data:application/pdf;base64,XXXX
       *
       * Nos quedamos con XXXX.
       */
      this.fileBase64 =
        result.split(',')[1];
    };

    reader.onerror = () => {

      this.fileBase64 = null;

      this.toastrService.danger(
        'No se ha podido leer el archivo PDF.',
        'Error'
      );
    };

    reader.readAsDataURL(file);
  }

  /*
   * ============================================================
   * ENVIAR AUTORIZACION
   * ============================================================
   */
  enviarAutorizacion(): void {

    if (!this.fileBase64) {

      this.toastrService.warning(
        'Debe seleccionar el PDF de autorización.',
        'Archivo requerido'
      );

      return;
    }

    const idowner =
      this.authService.pendingUser;

    if (!idowner) {

      this.toastrService.danger(
        'No se ha podido obtener el identificador del titular.',
        'Error'
      );

      return;
    }

    this.loading = true;

    this.repoService
      .enviarAutorizacion(
        this.fileBase64,
        idowner
      )
      .subscribe(
        () => {

          this.loading = false;

          this.toastrService.success(
            'La autorización se ha enviado correctamente.',
            'Autorización'
          );

        },

        error => {

          this.loading = false;

          console.error(
            'Error enviarAutorizacion',
            error
          );

          this.toastrService.danger(
            'No se ha podido enviar la autorización.',
            'Error'
          );
        }
      );
  }

  /*
   * ============================================================
   * DESCARGAR PDF
   * ============================================================
   */
  private descargarPdf(
    base64: string,
    fileName: string
  ): void {

    /*
     * Por si la Function devuelve
     * también el prefijo data:...
     */
    if (base64.includes(',')) {
      base64 = base64.split(',')[1];
    }

    const byteCharacters =
      atob(base64);

    const byteNumbers =
      new Array(byteCharacters.length);

    for (
      let i = 0;
      i < byteCharacters.length;
      i++
    ) {
      byteNumbers[i] =
        byteCharacters.charCodeAt(i);
    }

    const byteArray =
      new Uint8Array(byteNumbers);

    const blob =
      new Blob(
        [byteArray],
        {
          type: 'application/pdf'
        }
      );

    const url =
      window.URL.createObjectURL(blob);

    const link =
      document.createElement('a');

    link.href = url;

    link.download =
      fileName;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  }
}
